const checksum = (prefix, number) => {
  const checksumST = ['J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A'];
  const checksumFG = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'M', 'L', 'K'];
  const checksumM = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'J', 'L', 'K'];

  prefix = prefix.toUpperCase();
  let sum = 0;

  if (prefix === 'T' || prefix === 'G') {
    sum = 4;
  }
  if (prefix === 'M') {
    sum = 3;
  }

  sum = sum + stringToSum(number);
  switch (prefix) {
    case 'S':
    case 'T':
      return checksumST[sum % 11];
    case 'F':
    case 'G':
      return checksumFG[sum % 11];
    case 'M':
      return checksumM[sum % 11];
    default:
      throw new Error('Invalid prefix');
  }

  function stringToSum(number) {
    const factors = [2, 7, 6, 5, 4, 3, 2];
    return number
      .split('')
      .map(num => parseInt(num))
      .map((num, i) => num * factors[i])
      .reduce((a, b) => a + b, 0);
  }
};

export default checksum;